// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';
import blueCloud from '../../../images/blue-cloud.png';
import blueCloudMobile from '../../../images/blue-cloud-mobile.png';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 270px)',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  mainText: {
    color: GlobalStyles.color.COLOR_BLUE_LIGHTER,
    marginBottom: 30,
    [theme.breakpoints.down(500)]: {
      padding: '0 20px',
      textAlign: 'center',
    },
  },
  subText: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    textAlign: 'center',
    [theme.breakpoints.down(650)]: {
      padding: '0 25px',
    },
    [theme.breakpoints.down(500)]: {
      padding: '0',
    },
  },
  subContainer: {
    backgroundImage: `url(${blueCloud})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    width: 700,
    height: 400,
    padding: '20px 20px 40px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down(800)]: {
      width: 600,
      paddingBottom: 100,
    },
    [theme.breakpoints.down(650)]: {
      width: 450,
      height: 250,
      padding: '0 0 20px 0',
    },
    [theme.breakpoints.down(500)]: {
      backgroundImage: `url(${blueCloudMobile})`,
      minWidth: '100%',
      maxWidth: '100%',
      padding: '70px 0',
      height: 'auto',
      backgroundSize: '100% 100%',
    },
  },
  inputStyle: {
    '&::placeholder': {
      color: 'grey',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
    margin: '25px 0 20px 0',
    [theme.breakpoints.down(650)]: {
      margin: '5px 0 0 0',
    },
    [theme.breakpoints.down(500)]: {
      margin: '25px 0 20px 0',
    }
  },
  buttonStyle: {
    backgroundColor: 'transparent',
    border: `${GlobalStyles.color.COLOR_PRIMARY} solid 1px`
  },
  infoText: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    marginTop: -10,
    [theme.breakpoints.down(650)]: {
      marginTop: 0,
      marginBottom: -3,
    },
    [theme.breakpoints.down(500)]: {
      marginTop: -10,
      marginBottom: 0,
    },
  },
  errorText: {
    color: GlobalStyles.color.COLOR_GREY,
  },
  successText: {
    // color: GlobalStyles.color.COLOR_GREEN,
    color: 'rgb(180, 250, 150)',
  }
});

export default styles;
